import React, { useState } from "react";
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import Home from "./Components/Home";
import { Route, Routes } from "react-router-dom";
import CreatorDashboard from "./Components/CreatorDashboard";
import UserRegistration from "./Components/UserRegistration";
import Verifyuser from "./Components/Verifyuser";
import Requests from "./Components/Requests";
import UserDashboard from "./Components/UserDashboard";
import Files from "./Components/Files";
import UserFiles from "./Components/UserFiles";
import Dashboard from "./Components/AdminDashBoard/Dashboard";
import Packages from "./Components/AdminDashBoard/Packages";
import Users from "./Components/AdminDashBoard/Users";
import UserSettings from "./Components/UserSettings";
import BoxesRequests from "./Components/BoxesRequests";
import SuccessRequest from "./Components/Massages/SuccessRequest";
import SecondRequest from "./Components/SecondRequest";
function App() {
  const [show, setShow] = useState(true);
  const token = localStorage.getItem("token");
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/creator" element={<CreatorDashboard />} />
        <Route path="/user/:id/:email" element={<UserRegistration />} />
        <Route path="/verifyuser" element={<Verifyuser />} />
        <Route path="/requests" element={<Requests />} />
        <Route path="/boxesRequests" element={<BoxesRequests />} />
        <Route path="/UserSettings" element={<UserSettings />} />
        <Route path="/dashboard" element={<UserDashboard />} />
        <Route path="/files" element={<Files />} />
        <Route path="/userfiles" element={<UserFiles />} />
        <Route path="/adminDashboard" element={<Dashboard />} />
        <Route path="/packagesList" element={<Packages />} />
        <Route path="/usersInfo" element={<Users />} />
        <Route path="/successfullyRequested" element={<SuccessRequest />} />

        
        {/* <Route path="/request/:" element={<SuccessRequest />} /> */}
        <Route path="/request/:email/:id/:wallet" element={<SecondRequest />} />
      </Routes>
    </>
  );
}

export default App;
